// removed by extract-text-webpack-plugin
module.exports = {"fade-appear":"fade-appear","fade-appear-active":"fade-appear-active","fade-enter":"fade-enter","fade-enter-active":"fade-enter-active","fade-leave":"fade-leave","fade-leave-active":"fade-leave-active"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Transition/fade.scss
// module id = cMdt
// module chunks = 0